import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sigecom-toggle-button',
  template: `
    <button
      [disabled]="disabled" (click)="buttonClickedAction()"
      class="flex items-center gap-2 px-3 py-1.5 rounded shadow-flat-xl cursor-pointer justify-center whitespace-nowrap
      transition-colors duration-300 disabled:opacity-40 disabled:pointer-events-none {{ class }}"
      ngClass="clicked : "
    >
       <fa-icon [icon]="clicked ? 'xmark' : 'plus'"></fa-icon>
        <span> {{clicked ? 'Adicionado' : 'Adicionar' }} </span>

    </button>
  `,
})
export class ToggleButtonComponent {
  @Input() class?: string;
  @Input() disabled: boolean = false;
  @Output() buttonClicked = new EventEmitter<boolean>();

  protected clicked = false;

  buttonClickedAction(){
    this.clicked = !this.clicked
    this.buttonClicked.emit(this.clicked)
  }
}

